import { StaffRole } from '@urbanx/agx.auth.client';

export const RolesForTasks = [
  StaffRole.ListingsContributor,
  StaffRole.LaunchContributor,
  StaffRole.ContractsContributor,
  StaffRole.TransactionsContributor,
  StaffRole.AdminManager,
];
